// @flow

import React from "react";
import { localize } from "redux-i18n";
import classNames from "classnames";

import { Button, Icons, GSGrid, ComboBox } from "@components";
import type { OptionType } from "@components";
import type { StaffGroup } from "@modules/service/reducer/staff-groups/types";
import type { AlertStaffGroup } from "@modules/service/reducer/alerts/types";

import styles from "./alert-staff-groups.scss";

type AlertStaffGroupObj = Array<AlertStaffGroup>;

type OwnProps = $Exact<{
  data: AlertStaffGroupObj,
  options: Array<StaffGroup>,
  onChange: Function,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export class AlertStaffGroupsForm extends React.Component<Props> {
  get columns() {
    return [
      {
        name: this.props.t("ALERT_DETAILS_STAFF_GROUPS"),
        key: "name",
        cellClass: "p-0",
        renderCell: ({ row, rowIdx }: { row: AlertStaffGroup, rowIdx: number }) => {
          const selectedOption = this.props.options.find(option => option.id === row?.id);
          return (
            <ComboBox
              value={{ value: selectedOption?.id, label: selectedOption?.name }}
              className="flex-fill"
              options={this.options}
              onChange={this.handleUpdate(rowIdx)}
            />
          );
        },
      },
      {
        name: "",
        key: "remove",
        width: 50,
        cellClass: "p-0",
        renderCell: ({ row }: { row: AlertStaffGroup }) => (
          <div className="material-icons" onClick={this.handleRemove(row.id)}>
            delete
          </div>
        ),
      },
    ];
  }

  get data() {
    return this.props.data;
  }

  get options() {
    if (!this.props.options || !this.data) {
      return [];
    }

    return this.props.options
      .filter(r => !this.data || !this.data.find(d => d.id === r.id))
      .map(r => ({ value: r.id, label: r.name }));
  }

  handleAdd = () => {
    this.props.onChange([...this.data, { id: this.options[0].value }]);
  };

  handleUpdate = (rowIdx: number) => (val: OptionType) => {
    if (val === null) return val;
    let res = [...this.data];
    res[rowIdx] = { id: val };
    this.props.onChange(res);
  };

  handleRemove = (id: number) => () => {
    const next = this.data.filter(staffGroup => staffGroup.id !== id);
    this.props.onChange(next);
  };

  render() {
    return (
      <React.Fragment>
        <div className={classNames("alert-sgs__row alert-sgs__row--right")}>
          <Button
            materialIcon="add_box"
            className={classNames("link alert-sgs__add-button")}
            onClick={this.handleAdd}
            disabled={!this.options.length}
          >
            {this.props.t("ADD")}
          </Button>
        </div>
        <div className="mt-2">
          {/* TODO Grids on hover component */}
          {this.data ? (
            <GSGrid
              columns={this.columns}
              rows={this.data}
              noResultsText={this.props.t("NO_STAFF_GROUP_RESTIRCTIONS_MESSAGE")}
            />
          ) : null}
        </div>
      </React.Fragment>
    );
  }
}

export default localize()(AlertStaffGroupsForm);
